import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { useLabelStore } from "~/stores/use-label-store";
import { useVatRateStore } from "~/stores/use-vat-rate-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import VatRateForm from "./label-form";
import LabelForm from "./label-form";

export default function LabelDialog() {
  const {
    labelFormOpen,
    setLabelFormOpen,
    setSelectedLabel,
    selectedLabel,
    isLoading,
  } = useLabelStore();

  const { t } = useTranslation("common");

  const { checkUnsavedChanges } = useUnsavedChanges();

  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) return;
      }
      setSelectedLabel(undefined);
    }
    setLabelFormOpen(open);
  };

  return (
    <Dialog open={labelFormOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-xl w-full">
        <DialogHeader>
          <DialogTitle>{t("Labels.label")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <ScrollArea className="max-h-[80vh] p-4">
          <LabelForm
            label={selectedLabel}
            onClose={(force) => handleDialog(false, force)}
          />
        </ScrollArea>
        <DialogFooter>
          <Button
            className="w-full"
            disabled={isLoading}
            form="label-form"
            type="submit"
            variant="success"
          >
            {selectedLabel ? t("update") : t("create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
